const features = [
  {
    icon: 'ri-4k-fill',
    iconColor: 'text-primary-400',
    bgColor: 'bg-primary-500/10',
    title: '高清画质',
    desc: '全站支持 1080P 与 4K 高清电影播放，每一帧都清晰细腻，还原影院级视觉体验。深夜观影不将就，画质清晰才过瘾。',
  },
  {
    icon: 'ri-stack-fill',
    iconColor: 'text-accent-400',
    bgColor: 'bg-accent-500/10',
    title: '海量片库',
    desc: '收录动作、悬疑、科幻、喜剧、爱情、动画、纪录、恐怖等全类型影片，经典老片与最新电影在线看一站搞定，持续扩充中。',
  },
  {
    icon: 'ri-speed-up-fill',
    iconColor: 'text-primary-400',
    bgColor: 'bg-primary-500/10',
    title: '深夜不卡',
    desc: '专为深夜观影场景优化的播放线路，多节点负载均衡，告别缓冲等待。无论是热门电影推荐还是小众独立电影，播放流畅稳定。',
  },
  {
    icon: 'ri-calendar-check-fill',
    iconColor: 'text-secondary-400',
    bgColor: 'bg-secondary-500/10',
    title: '每日更新',
    desc: '编辑团队每日精选最新资源，热门电影推荐准时上线。每晚 20:00 准时更新片单，让你不错过任何一部值得看的好电影。',
  },
  {
    icon: 'ri-vip-crown-fill',
    iconColor: 'text-accent-400',
    bgColor: 'bg-accent-500/10',
    title: '完全免费',
    desc: '所有电影在线观看完全免费，无需注册、无隐藏收费。享受纯粹的电影大全免费体验，让每一个深夜影迷都能轻松看片。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-star-fill text-primary-400 text-xs"></i></span>
            <span className="text-xs text-primary-400 font-medium whitespace-nowrap">平台优势</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">观影优势</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">为什么数百万影迷选择夜猫影院作为深夜观影首选</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((f) => (
            <div
              key={f.title}
              className="group flex flex-col items-center text-center p-5 rounded-lg bg-background-50 border border-background-200/50 hover:border-primary-500/20 transition-all"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-full ${f.bgColor} mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${f.icon} ${f.iconColor} text-xl`}></i>
              </span>
              <h3 className="text-sm font-medium text-foreground-100 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-400 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}